<template>
  <div>
    <rl-carousel v-model="slide1" @slide-changed="value => (slide2 = value)">
      <div slot-scope="{ wrapperStyles, slides: { count, active } }">
        <div class="overflow-hidden text-center">
          <div v-bind="wrapperStyles">
            <slot name="first"></slot>
          </div>
        </div>
        <div class="mt-4 text-center">
          <span
            v-for="(item, index) in count"
            :key="index"
            class="mx-1 cursor-pointer"
            @click="slide1 = index"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="20"
              class="stroke-current"
              :class="{
                'text-grey': active !== index,
                'text-grey-dark': active === index
              }"
            >
              <line x1="0" y1="10" x2="30" y2="10" stroke-width="2" />
            </svg>
          </span>
        </div>
      </div>
    </rl-carousel>
    <rl-carousel v-model="slide2" @slide-changed="value => (slide1 = value)">
      <div slot-scope="{ wrapperStyles, slides: { count, active } }">
        <div class="overflow-hidden text-center">
          <div v-bind="wrapperStyles">
            <slot name="second"></slot>
          </div>
        </div>
        <div class="mt-4 text-center">
          <span
            v-for="(item, index) in count"
            :key="index"
            class="mx-1 cursor-pointer"
            @click="slide2 = index"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="20"
              class="stroke-current"
              :class="{
                'text-grey': active !== index,
                'text-grey-dark': active === index
              }"
            >
              <line x1="0" y1="10" x2="30" y2="10" stroke-width="2" />
            </svg>
          </span>
        </div>
      </div>
    </rl-carousel>
  </div>
</template>

<script>
import { RlCarousel } from 'vue-renderless-carousel'

export default {
  name: 'synchronized-carousel',
  components: {
    RlCarousel
  },
  data() {
    return {
      slide1: 0,
      slide2: 0
    }
  }
}
</script>

<style lang="less" scoped>
svg {
  transition: color 0.5s ease;
}
</style>
